import React from 'react';

interface SocialIconProps {
    icon: string;
    href?: string;
}

const SocialIcon: React.FC<SocialIconProps> = ({ icon, href }) => {
    const content = (
        <div className="w-8 h-8 bg-gray-700 hover:bg-accent rounded-full flex items-center justify-center transition-colors duration-300 cursor-pointer group">
            <span className="text-sm group-hover:scale-110 transition-transform duration-300">{icon}</span>
        </div>
    );

    if (href) {
        return <a href={href}>{content}</a>;
    }

    return content;
};

export default SocialIcon;
